import axios from 'axios';

import { LogService } from '../log-service';

export const getSellerServiceLevels = async () => {
  try {
    const response = await axios.get('/provider/serviceLevels');
    const result = response?.data ?? { providerServiceLevels: [] };
    return result.providerServiceLevels;
  } catch (error) {
    LogService.logError(new Error('Error fetching seller service levels', { cause: error }));
    throw error;
  }
};
